import React from "react";
import styled from "styled-components";

const ExploreCard = ({product}) => {
  return (
    <TheExploreCard>
      <div className="card-image">
        <img src={product.images[0]} alt={product.name} />
      </div>
      <p className="card-title">{product.name}</p>
      <p className="short-info">
        {product.description.length > 30
          ? product.description.substring(0, 35) + "....."
          : product.description}
      </p>
      <a href={`/equipments/${product.id}`} className="view-more">
        VIEW DETAILS
      </a>
    </TheExploreCard>
  );
};

const TheExploreCard = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  gap: 0.5rem;
  .card-image {
    width: 100%;
    height: 250px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .card-title {
    font-size: 1rem;
    font-weight: 600;
    color: var(--primary-color);
  }
  .short-info {
    font-weight: 400;
    color: var(--primary-color);
    height: 2.5rem;
  }
  .view-more {
    display: inline-block;
    background: var(--third-color);
    color: var(--primary-color);
    padding: 0.5rem 2rem;
    /* border-radius: 0.5rem; */
    text-decoration: none;
    font-weight: 600;
    transition: var(--transition);
    width: 100%;
    text-align: center;
    font-size: 0.8rem;
    letter-spacing: 0.1rem;

    &:hover {
      background: var(--primary-color);
      color: var(--second-color);
    }
  }
  @media screen and (max-width: 1366px) {
  }
  @media screen and (max-width: 1200px) {
  }
  @media screen and (max-width: 900px) {
  }
  @media screen and (max-width: 600px) {
    .card-image {
      width: 100%;
      height: 200px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .card-title {
      font-size: 1rem;
      font-weight: 600;
      color: var(--primary-color);
      height: 2rem;
    }
    .short-info {
      font-weight: 400;
      color: var(--primary-color);
      font-size: 0.7rem;
      height: 1.5rem;
    }
    .view-more {
      display: inline-block;
      background: var(--third-color);
      color: var(--primary-color);
      padding: 0.5rem 2rem;
      /* border-radius: 0.5rem; */
      text-decoration: none;
      font-weight: 600;
      transition: var(--transition);
      width: 100%;
      text-align: center;
      font-size: 0.7rem;

      &:hover {
        background: var(--primary-color);
        color: var(--second-color);
      }
    }
  }
  @media screen and (max-width: 420px) {
  }
  @media screen and (max-width: 350px) {
  }
`;
export default ExploreCard;
